import React, { useContext } from 'react';

const UserContext = React.createContext({
  user: null,
  loggedIn: false,
  loggingIn: false,
  kickUserOut: () => {},
  logout: () => {},
  refreshUser: () => {},
  onLogin: () => {},
  isVerified: false
});

export const useUser = () => {
  return useContext(UserContext);
};

export default UserContext;
